import Axios from 'axios';

const municipalityUrl = `${location.href}/api/municipality`;

export default class Municipality {
	static async search(search) {
		const response = await Axios.get(municipalityUrl, {
			params: {
				search,
			},
		});

		return response.data.data.municipalities;
	}
}



// WEBPACK FOOTER //
// ./assets/js/services/municipality.js